/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  PaginatedWorkshopsResponse,
  WorkshopCreate,
  WorkshopListSummary,
  WorkshopMentorOption,
  WorkshopRead,
  WorkshopResults,
  WorkshopUpdate,
  WorkshopWithProblems,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PaginatedWorkshopsResponseFromJSON,
    PaginatedWorkshopsResponseToJSON,
    WorkshopCreateFromJSON,
    WorkshopCreateToJSON,
    WorkshopListSummaryFromJSON,
    WorkshopListSummaryToJSON,
    WorkshopMentorOptionFromJSON,
    WorkshopMentorOptionToJSON,
    WorkshopReadFromJSON,
    WorkshopReadToJSON,
    WorkshopResultsFromJSON,
    WorkshopResultsToJSON,
    WorkshopUpdateFromJSON,
    WorkshopUpdateToJSON,
    WorkshopWithProblemsFromJSON,
    WorkshopWithProblemsToJSON,
} from '../models/index';

export interface CreateWorkshopRequest {
    workshopCreate: WorkshopCreate;
    xOrganizationID?: string | null;
}

export interface DeleteWorkshopRequest {
    workshopId: string;
    xOrganizationID?: string | null;
}

export interface GetWorkshopRequest {
    workshopId: string;
    xOrganizationID?: string | null;
}

export interface GetWorkshopResultsRequest {
    workshopId: string;
    xOrganizationID?: string | null;
}

export interface GetWorkshopsSummaryRequest {
    xOrganizationID?: string | null;
}

export interface ListWorkshopMentorsRequest {
    xOrganizationID?: string | null;
}

export interface ListWorkshopsRequest {
    startFrom?: Date | null;
    startTo?: Date | null;
    endAfter?: Date | null;
    xOrganizationID?: string | null;
}

export interface ListWorkshopsByClassRequest {
    classId: string;
    seriesId?: string | null;
    xOrganizationID?: string | null;
}

export interface ListWorkshopsBySeriesRequest {
    seriesId: string;
    xOrganizationID?: string | null;
}

export interface ListWorkshopsPageRequest {
    status?: ListWorkshopsPageStatusEnum;
    classId?: string | null;
    mentorId?: string | null;
    search?: string | null;
    skip?: number;
    limit?: number;
    xOrganizationID?: string | null;
}

export interface UpdateWorkshopRequest {
    workshopId: string;
    workshopUpdate: WorkshopUpdate;
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class WorkshopsApi extends runtime.BaseAPI {

    /**
     * Create a workshop in the current organization. Staff there; only administrators and content creators may assign another mentor.  With class_id and add_class_members (default true), the class members become participants.
     * Create Workshop
     */
    async createWorkshopRaw(requestParameters: CreateWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopRead>> {
        if (requestParameters['workshopCreate'] == null) {
            throw new runtime.RequiredError(
                'workshopCreate',
                'Required parameter "workshopCreate" was null or undefined when calling createWorkshop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopCreateToJSON(requestParameters['workshopCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopReadFromJSON(jsonValue));
    }

    /**
     * Create a workshop in the current organization. Staff there; only administrators and content creators may assign another mentor.  With class_id and add_class_members (default true), the class members become participants.
     * Create Workshop
     */
    async createWorkshop(requestParameters: CreateWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopRead> {
        const response = await this.createWorkshopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete (deactivate) a workshop. Organization admin or mentor.
     * Delete Workshop
     */
    async deleteWorkshopRaw(requestParameters: DeleteWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling deleteWorkshop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete (deactivate) a workshop. Organization admin or mentor.
     * Delete Workshop
     */
    async deleteWorkshop(requestParameters: DeleteWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWorkshopRaw(requestParameters, initOverrides);
    }

    /**
     * Get a workshop with its problems. Organization admin, mentor or participant.
     * Get Workshop
     */
    async getWorkshopRaw(requestParameters: GetWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopWithProblems>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling getWorkshop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopWithProblemsFromJSON(jsonValue));
    }

    /**
     * Get a workshop with its problems. Organization admin, mentor or participant.
     * Get Workshop
     */
    async getWorkshop(requestParameters: GetWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopWithProblems> {
        const response = await this.getWorkshopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get workshop results with all data in one call: - Workshop problems (name, points, order; no statement or solution code) - Attendance - One score per attendee and workshop problem (best points, attempts, last submission   time); no submissions and no source code, since the results view polls this
     * Get Workshop Results
     */
    async getWorkshopResultsRaw(requestParameters: GetWorkshopResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopResults>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling getWorkshopResults().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/results`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopResultsFromJSON(jsonValue));
    }

    /**
     * Get workshop results with all data in one call: - Workshop problems (name, points, order; no statement or solution code) - Attendance - One score per attendee and workshop problem (best points, attempts, last submission   time); no submissions and no source code, since the results view polls this
     * Get Workshop Results
     */
    async getWorkshopResults(requestParameters: GetWorkshopResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopResults> {
        const response = await this.getWorkshopResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The counters above the workshops list: workshops today and this week.  Over the workshops the caller may read (as in `GET /workshops/`), by Europe/Zagreb days: `today` overlaps today, `this_week` overlaps the days from today to the coming Sunday.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization
     * Get Workshops Summary
     */
    async getWorkshopsSummaryRaw(requestParameters: GetWorkshopsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopListSummary>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopListSummaryFromJSON(jsonValue));
    }

    /**
     * The counters above the workshops list: workshops today and this week.  Over the workshops the caller may read (as in `GET /workshops/`), by Europe/Zagreb days: `today` overlaps today, `this_week` overlaps the days from today to the coming Sunday.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization
     * Get Workshops Summary
     */
    async getWorkshopsSummary(requestParameters: GetWorkshopsSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopListSummary> {
        const response = await this.getWorkshopsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The mentors of the workshops the caller may read, once each, for the mentor filter.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization
     * List Workshop Mentors
     */
    async listWorkshopMentorsRaw(requestParameters: ListWorkshopMentorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopMentorOption>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/mentors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopMentorOptionFromJSON));
    }

    /**
     * The mentors of the workshops the caller may read, once each, for the mentor filter.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization
     * List Workshop Mentors
     */
    async listWorkshopMentors(requestParameters: ListWorkshopMentorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopMentorOption>> {
        const response = await this.listWorkshopMentorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the organization\'s workshops: all for admins, own (mentor or participant) for staff.  Ordered by start time, unpaged; the attendance report and the calendar use it for one period. The optional `start_from` (inclusive) and `start_to` (exclusive) keep the workshops that start in that range; `end_after` (exclusive) keeps those ending after it, so `end_after` with `start_to` gives every workshop overlapping that window. Send ISO 8601 with an offset (`2026-10-01T00:00:00+02:00`); a value without one is read as UTC.
     * List Workshops
     */
    async listWorkshopsRaw(requestParameters: ListWorkshopsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopRead>>> {
        const queryParameters: any = {};

        if (requestParameters['startFrom'] != null) {
            queryParameters['start_from'] = (requestParameters['startFrom'] as any).toISOString();
        }

        if (requestParameters['startTo'] != null) {
            queryParameters['start_to'] = (requestParameters['startTo'] as any).toISOString();
        }

        if (requestParameters['endAfter'] != null) {
            queryParameters['end_after'] = (requestParameters['endAfter'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopReadFromJSON));
    }

    /**
     * List the organization\'s workshops: all for admins, own (mentor or participant) for staff.  Ordered by start time, unpaged; the attendance report and the calendar use it for one period. The optional `start_from` (inclusive) and `start_to` (exclusive) keep the workshops that start in that range; `end_after` (exclusive) keeps those ending after it, so `end_after` with `start_to` gives every workshop overlapping that window. Send ISO 8601 with an offset (`2026-10-01T00:00:00+02:00`); a value without one is read as UTC.
     * List Workshops
     */
    async listWorkshops(requestParameters: ListWorkshopsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopRead>> {
        const response = await this.listWorkshopsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the caller\'s readable workshops labelled with a class, optionally by series.
     * List Workshops By Class
     */
    async listWorkshopsByClassRaw(requestParameters: ListWorkshopsByClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopRead>>> {
        if (requestParameters['classId'] == null) {
            throw new runtime.RequiredError(
                'classId',
                'Required parameter "classId" was null or undefined when calling listWorkshopsByClass().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['seriesId'] != null) {
            queryParameters['series_id'] = requestParameters['seriesId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/class/{class_id}`.replace(`{${"class_id"}}`, encodeURIComponent(String(requestParameters['classId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopReadFromJSON));
    }

    /**
     * List the caller\'s readable workshops labelled with a class, optionally by series.
     * List Workshops By Class
     */
    async listWorkshopsByClass(requestParameters: ListWorkshopsByClassRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopRead>> {
        const response = await this.listWorkshopsByClassRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the caller\'s readable workshops in a series of the current organization.
     * List Workshops By Series
     */
    async listWorkshopsBySeriesRaw(requestParameters: ListWorkshopsBySeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopRead>>> {
        if (requestParameters['seriesId'] == null) {
            throw new runtime.RequiredError(
                'seriesId',
                'Required parameter "seriesId" was null or undefined when calling listWorkshopsBySeries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/series/{series_id}`.replace(`{${"series_id"}}`, encodeURIComponent(String(requestParameters['seriesId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopReadFromJSON));
    }

    /**
     * List the caller\'s readable workshops in a series of the current organization.
     * List Workshops By Series
     */
    async listWorkshopsBySeries(requestParameters: ListWorkshopsBySeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopRead>> {
        const response = await this.listWorkshopsBySeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * One page of the workshops list, filtered by status, class, mentor and search.  Who sees what is as in `GET /workshops/`: admins every active workshop of the organization, other staff those they mentor or attend. A workshop runs from its start up to, but excluding, its end, against the server\'s clock. Running and upcoming workshops come first by start, then ended ones by start, newest first.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 422 for an unknown status, a malformed id, a negative skip, a limit         outside 1..200 or a search over 200 characters
     * List Workshops Page
     */
    async listWorkshopsPageRaw(requestParameters: ListWorkshopsPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedWorkshopsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['classId'] != null) {
            queryParameters['class_id'] = requestParameters['classId'];
        }

        if (requestParameters['mentorId'] != null) {
            queryParameters['mentor_id'] = requestParameters['mentorId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedWorkshopsResponseFromJSON(jsonValue));
    }

    /**
     * One page of the workshops list, filtered by status, class, mentor and search.  Who sees what is as in `GET /workshops/`: admins every active workshop of the organization, other staff those they mentor or attend. A workshop runs from its start up to, but excluding, its end, against the server\'s clock. Running and upcoming workshops come first by start, then ended ones by start, newest first.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 422 for an unknown status, a malformed id, a negative skip, a limit         outside 1..200 or a search over 200 characters
     * List Workshops Page
     */
    async listWorkshopsPage(requestParameters: ListWorkshopsPageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedWorkshopsResponse> {
        const response = await this.listWorkshopsPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a workshop. Organization admin or mentor; class_id changes never touch participants.
     * Update Workshop
     */
    async updateWorkshopRaw(requestParameters: UpdateWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopRead>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling updateWorkshop().'
            );
        }

        if (requestParameters['workshopUpdate'] == null) {
            throw new runtime.RequiredError(
                'workshopUpdate',
                'Required parameter "workshopUpdate" was null or undefined when calling updateWorkshop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopUpdateToJSON(requestParameters['workshopUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopReadFromJSON(jsonValue));
    }

    /**
     * Update a workshop. Organization admin or mentor; class_id changes never touch participants.
     * Update Workshop
     */
    async updateWorkshop(requestParameters: UpdateWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopRead> {
        const response = await this.updateWorkshopRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListWorkshopsPageStatusEnum = {
    Today: 'today',
    Upcoming: 'upcoming',
    Past: 'past',
    All: 'all'
} as const;
export type ListWorkshopsPageStatusEnum = typeof ListWorkshopsPageStatusEnum[keyof typeof ListWorkshopsPageStatusEnum];
